// utils/ocr.ts
import { createWorker, Worker, PSM } from 'tesseract.js';

let workerPromise: Promise<Worker> | null = null;

export async function getOcrWorker() {
  if (!workerPromise) {
    workerPromise = (async () => {
      const worker = await createWorker();
      await worker.loadLanguage('eng');
      await worker.initialize('eng');
    //   await worker.setParameters({
    //     user_defined_dpi: '300',
    //     tessedit_char_whitelist:
    //       'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789:/._-?&=#%+@()[]{}~',
    //   });
      return worker;
    })();
  }
  return workerPromise;
}

export function preprocessImage(src: string): Promise<string> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const maxW = 2000;
      const scale = img.width < maxW ? maxW / img.width : 1;
      const w = Math.round(img.width * scale);
      const h = Math.round(img.height * scale);

      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d')!;

      ctx.drawImage(img, 0, 0, w, h);

      // grayscale + threshold
      const imageData = ctx.getImageData(0, 0, w, h);
      const d = imageData.data;
      for (let i = 0; i < d.length; i += 4) {
        const v = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
        const bin = v > 180 ? 255 : 0;
        d[i] = d[i + 1] = d[i + 2] = bin;
      }
      ctx.putImageData(imageData, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.crossOrigin = 'anonymous';
    img.src = src;
  });
}

export function normalizeUrls(raw: string): string {
    let s = raw;
  
    s = s.replace(/\u00AD/g, '').replace(/(\S)-\n(\S)/g, '$1$2');
  
    s = s.replace(
      /h\s*[\W_]*\s*t\s*[\W_]*\s*t\s*[\W_]*\s*p\s*[\W_]*\s*s?\s*:\s*\/\s*\/?/gi,
      (m) => (m.toLowerCase().includes('https') ? 'https://' : 'http://')
    );
  
    s = s.replace(/\bht{1,3}ps?:\/{1,2}/gi, (m) =>
      m.toLowerCase().includes('https') || m.toLowerCase().includes('ps')
        ? 'https://'
        : 'http://'
    );
  
    s = s.replace(/\b(https?):\/(?!\/)/gi, (_, p1) => `${p1}://`);
  
    s = s.replace(/\b(https?:\/\/)+(?!\/)/gi, 'https://');
  
    s = s.replace(/https?:\/\/\s+/gi, (m) => m.replace(/\s+/g, ''));
  
    return s;
  }